var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToCommunity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 6136",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.111,
    height: 10.502,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6585",
    d: "M9.888 5.251a2.625 2.625 0 112.626-2.625 2.625 2.625 0 01-2.626 2.625zm0-1.141a1.484 1.484 0 10-1.484-1.484 1.484 1.484 0 001.484 1.483zm4.224 5.822a.571.571 0 11-1.141 0 3.082 3.082 0 10-6.164 0 .571.571 0 01-1.142 0 4.224 4.224 0 118.447 0z",
    fill: "#4b26e7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6586",
    d: "M4.224 5.251a2.625 2.625 0 112.625-2.625 2.625 2.625 0 01-2.625 2.625zm0-1.141A1.484 1.484 0 102.74 2.626a1.484 1.484 0 001.484 1.483zm4.224 5.822a.571.571 0 01-1.142 0 3.082 3.082 0 10-6.164 0 .571.571 0 01-1.141 0 4.224 4.224 0 018.447 0z",
    fill: "#4b26e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCommunity);
export default __webpack_public_path__ + "static/media/AddToCommunity.1f5e10ac2ce052992c92f8a43fbc10d6.svg";
export { ForwardRef as ReactComponent };